import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import {
  ProductCategory,
  States,
  User,
  UserFormValues,
  VendorScoreForm,
  VendorsResponse,
  VendorRegistrationForm,
  PasswordChangeForm,
  PasswordOtpData,
  AccountInformation,
  VendorUpdateForm,
  DashboardInfo,
  IPieChartModel,
  IStatModel,
  ITransactionModel,
  IGraphModel,
  INotificationModel,
  IUserRoleModel,
  IUserRoleForm,
  IVendorUsers,
  IUserRole,
  UpdateUserRole,
} from "../models/user";
import { router } from "../router/Routes";
import { store } from "./store";
import { toast } from "react-toastify";
import { TermsForm } from "../models/terms";
import { PagingParams } from "../models/pagination";
import { resolve } from "path";

export default class UserStore {
  user: User | null = null;
  loadingScore = true;
  loadingInitial = "";
  scoreResponse: VendorsResponse | null = null;
  registerIsSuccess = "";
  status = "";
  userProductCategories: ProductCategory[] = [];
  userStates: States[] = [];
  loginStatus = "";
  emailStatus = "";
  guidStatus = "";
  accountInformation: AccountInformation = new AccountInformation();
  dashLoadingInitial = "";
  notificationsLoading = "";
  rolesLoading = "";
  dashboardData: DashboardInfo | null = null;
  barData: IStatModel[] = [];
  graphData: IGraphModel[] = [];
  pieChartData: IPieChartModel[] = [];
  transactions: ITransactionModel[] = [];
  notifications: INotificationModel[] = [];
  userRoles: IUserRoleModel[] = [];
  currentUserRole: IUserRole | null = null;
  userList: IVendorUsers[] = [];
  activeUserList: IVendorUsers[] = [];
  inactiveUserList: IVendorUsers[] = [];
  vendorCac: string | null = "";

  constructor() {
    makeAutoObservable(this);
  }

  get isLoggedIn() {
    return !!this.user;
  }
  setGuidStatus = (x: string) => {
    this.guidStatus = x;
  };
  setLoadingScore = (state: boolean) => {
    this.loadingScore = state;
  };
  setRegisterIsSuccess = (state: string) => {
    this.registerIsSuccess = state;
  };
  setStatus = (state: string) => {
    this.status = state;
  };
  setLoginStatus = (state: string) => {
    this.loginStatus = state;
  };
  getEligibility = async (creds: VendorScoreForm) => {
    this.setLoadingScore(true);
    try {
      const response = await agent.Account.getEligibility(creds);
      // store.commonStore.setToken(user.token);
      runInAction(() => {
        this.scoreResponse = response;
      });
      this.setLoadingScore(false);
    } catch (error) {
      this.setLoadingScore(false);
      throw error;
    }
  };
  getCategories = async (params?: PagingParams) => {
    this.setStatus("loading");
    try {
      const response = await agent.Account.getCategories(
        params ? params : new PagingParams()
      );
      // store.commonStore.setToken(user.token);
      runInAction(() => {
        if (response.data === null) {
          this.userProductCategories = [];
        } else this.userProductCategories = response.data;
      });
      this.setStatus("idle");
    } catch (error) {
      this.setStatus("idle");
      throw error;
    }
  };
  getStates = async () => {
    this.setStatus("loading");
    try {
      const response = await agent.Account.getStateCodes();
      // store.commonStore.setToken(user.token);
      runInAction(() => {
        this.userStates = response.data;
      });
      this.setStatus("idle");
    } catch (error) {
      this.setStatus("idle");
      throw error;
    }
  };

  getAccountInfo = async () => {
    this.setStatus("loading");
    try {
      const response = await agent.Account.getAccountInfo();
      // store.commonStore.setToken(user.token);
      if (response.isSuccessful) {
        runInAction(() => {
          this.accountInformation = response.data;
        });
      } else {
        toast.error(response.responseMessage);
      }
      this.setStatus("");
      return response;
    } catch (error) {
      this.setStatus("");
      throw error;
    }
  };

  login = async (creds: UserFormValues) => {
    this.loginStatus = "loading";
    // toast.info("Check toast")
    try {
      const user = await agent.Account.login(creds);
      // console.log(user);
      if (user.isSuccessful) {
        store.commonStore.setToken(user.data.access_token);
        store.commonStore.setRefToken(user.data.refresh_token);
        store.commonStore.setLoggedInUser(user.data);
        runInAction(() => (this.loginStatus = ""));
        router.navigate("/vendor/dashboard");
      } else if (user.responseCode === "04") {
        throw user.responseMessage;
      } else if (user.responseCode === "03") {
        throw user.responseMessage;
      }else if(user.responseCode === "99"){
        throw user.responseMessage;
      }
       else {
        runInAction(() => (this.loginStatus = ""));
        const error = "Invalid Credentials";
        throw error;
      }
      // store.modalStore.closeModal();
    } catch (error) {
      this.loginStatus = "";
      var error2 = "Problem validating credentials";
      // console.log(error);
      if (typeof error === typeof "") throw error;
      else throw error2;
    }
  };

  register = async (creds: VendorRegistrationForm) => {
    this.registerIsSuccess = "loading";
    try {
      const user = await agent.Account.register(creds);
      if (user.isSuccessful) {
        runInAction(() => (this.registerIsSuccess = "success"));
      } else
        runInAction(() => {
          this.registerIsSuccess = "";
          toast.info(user.responseMessage);
        });

      //   router.navigate("/activities");
      //   store.modalStore.closeModal();
    } catch (error) {
      this.registerIsSuccess = "";
      throw error;
    }
  };

  updateVendor = async (creds: VendorUpdateForm) => {
    this.status = "loading";
    try {
      const response = await agent.Account.updateAccountInfo(creds);
      toast.info(response.responseMessage);
      runInAction(() => (this.status = ""));
      return response;

      //   router.navigate("/activities");
      //   store.modalStore.closeModal();
    } catch (error) {
      this.status = "";
      throw error;
    }
  };

  forgotPassword = async (creds: string) => {
    this.loginStatus = "loading";
    try {
      const response = await agent.Account.forgotPassword(creds);
      // console.log(response);
      runInAction(() => (this.loginStatus = ""));
      return response;
      // if (response.isSuccessful) {
      //   runInAction(() => (this.loginStatus = ""));
      //   return "success";
      // } else {
      //   runInAction(() => (this.loginStatus = ""));
      //   return response.responseMessage;
      // }
      // store.modalStore.closeModal();
    } catch (error) {
      this.loginStatus = "";
      throw error;
    }
  };

  verifyOtp = async (creds: PasswordOtpData) => {
    this.loginStatus = "loading";
    try {
      const response = await agent.Account.verifyPasswordOtp(creds);
      // console.log(response);
      runInAction(() => (this.loginStatus = ""));
      return response;
      // if (response.isSuccessful) {
      //   runInAction(() => (this.loginStatus = ""));
      //   return response;
      // } else {
      //   runInAction(() => (this.loginStatus = ""));
      //   return response.responseMessage
      // }
      // store.modalStore.closeModal();
    } catch (error) {
      this.loginStatus = "";
      throw error;
    }
  };

  changePassword = async (creds: PasswordChangeForm) => {
    this.loginStatus = "loading";
    try {
      const response = await agent.Account.changePassword(creds);
      // console.log(response);
      runInAction(() => (this.loginStatus = ""));
      return response;
      // if (response.data) {
      //   runInAction(() => (this.loginStatus = ""));
      //   return "success";
      // } else {
      //   runInAction(() => (this.loginStatus = ""));
      //   const error = "Invalid Credentials";
      //   throw error;
      // }
      // store.modalStore.closeModal();
    } catch (error) {
      this.loginStatus = "";
      throw error;
    }
  };

  verifyEmail = async (creds: string) => {
    this.emailStatus = "loading";
    try {
      const response = await agent.Account.verifyEmail({email:creds});
      // console.log(response);

      if (response.isSuccessful) {
        runInAction(() => (this.emailStatus = ""));
        return "success";
      } else {
        runInAction(() => (this.emailStatus = ""));
        const error = "Invalid Credentials";
        throw error;
      }
      // store.modalStore.closeModal();
    } catch (error) {
      this.emailStatus = "";
      throw error;
    }
  };



  logout = async() => {
    const response = await agent.Account.logoutUser()
    toast.info(response.responseMessage);
    store.commonStore.clearLocalStorage();
    router.navigate("/");
    // this.user = null;
    // router.navigate("/");
  };

  getDashboardInfo = async () => {
    this.dashLoadingInitial = "loading";
    try {
      const response = await agent.Profiles.getVendorMatrix();
      if (response.isSuccessful)
        runInAction(() => {
          this.dashboardData = response.data;
          this.barData = [
            {
              name: "Live on site",
              uv: this.dashboardData!.vendorProducts.liveProducts,
            },
            {
              name: "Sold out",
              uv: this.dashboardData!.vendorProducts.soldOut,
            },
            {
              name: "Rejected",
              uv: this.dashboardData!.vendorProducts.rejected,
            },
          ];
          this.graphData = [
            {
              name: "JAN",
              amount: this.dashboardData!.monthlyTransaction.jan,
            },
            {
              name: "MAR",
              amount: this.dashboardData!.monthlyTransaction.mar,
            },
            {
              name: "MAY",
              amount: this.dashboardData!.monthlyTransaction.may,
            },
            {
              name: "JUL",
              amount: this.dashboardData!.monthlyTransaction.jul,
            },
            {
              name: "SEP",
              amount: this.dashboardData!.monthlyTransaction.sep,
            },
            {
              name: "NOV",
              amount: this.dashboardData!.monthlyTransaction.nov,
            },
            // {
            //   name: "DEC",
            //   amount: 3490,
            //   // pv: 4300,
            //   // amt: 2100,
            // },
          ];
          this.pieChartData = [
            {
              name: "cancelled",
              orders: this.dashboardData!.vendorOrder.cancelled,
            },
            {
              name: "returned",
              orders: this.dashboardData!.vendorOrder.returned,
            },
          ];
        });

      this.dashLoadingInitial = "";
      // console.log(response);
      return response;
    } catch (error) {
      this.dashLoadingInitial = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };
  padTo2Digits(num: any) {
    return num.toString().padStart(2, "0");
  }
  getVendorNotifications = async () => {
    this.notificationsLoading = "loading";
    try {
      let dateRequest = new Date();
      dateRequest.setDate(dateRequest.getDate());

      const cred = [
        dateRequest.getFullYear(),
        this.padTo2Digits(dateRequest.getMonth() + 1),
        this.padTo2Digits(dateRequest.getDate()),
      ].join("-");
      const response = await agent.Profiles.getVendorNotifications(cred);
      if (response.isSuccessful)
        runInAction(() => {
          this.notifications = response.data;
        });

      this.notificationsLoading = "";
      // console.log(response);
      return response;
    } catch (error) {
      this.notificationsLoading = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };
  getUser = async () => {
    try {
      // const user = await agent.Account.current();
      // runInAction(() => this.user = user);
    } catch (error) {
      // console.log(error);
    }
  };
  fetchUserRole = async (id: string) => {
    this.guidStatus = "loading";
    try {
      const response = await agent.Profiles.getUserRole(id);
      if (response.isSuccessful)
        runInAction(() => {
          this.currentUserRole = response.data;
        });
      else {
        toast.info(response.responseMessage);
        router.navigate("/vendor/shipping/returnlocationlist");
      }
      // this.guidStatus = "";
      return response;
    } catch (error) {
      this.guidStatus = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };
  updateUserRole = async (creds: UpdateUserRole) => {
    this.rolesLoading = "loading";
    try {
      const response = await agent.Profiles.updateUserRole(creds);
      if (response.isSuccessful) {
        runInAction(() => (this.rolesLoading = ""));
        await this.getVendorUsers("");
      } else
        runInAction(() => {
          this.rolesLoading = "";
          toast.info(response.responseMessage);
        });
    } catch (error) {
      this.rolesLoading = "";
      throw error;
    }
  };
  getVendorRoles = async () => {
    this.rolesLoading = "loading";
    try {
      const response = await agent.Profiles.getVendorRoles();
      if (response.isSuccessful)
        runInAction(() => {
          this.userRoles = response.data;
        });

      this.rolesLoading = "";
      // console.log(response);
      return response;
    } catch (error) {
      this.rolesLoading = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };

  getVendorUsers = async (searchTerm : string) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Profiles.getVendorUsers(searchTerm);
      if (response.isSuccessful && response.data) {
        runInAction(() => {
          this.userList = response.data;
          
          // Handle filtering for inactive users
          this.inactiveUserList = response.data.filter(
            (user: { status: string; roleName: string }) => {
              return (
                user.status !== "Active" &&
                user.status !== "active" &&
                user.roleName !== "Owner"
              );
            }
          );
          
          // Handle filtering for active users
          this.activeUserList = response.data.filter(
            (user: { status: string; roleName: string }) => {
              return (
                user.status === "Active" ||
                user.status === "active" ||
                user.roleName === "Owner"
              );
            }
          );
        });
      } else {
        // Handle case where response data is null or not successful
        console.warn("No valid user data received.");
        // Optionally, you can initialize empty arrays or handle this case as needed
        this.userList = [];
        this.inactiveUserList = [];
        this.activeUserList = [];
      }
      

      this.loadingInitial = "";
      // console.log(response);
      return response;
    } catch (error) {
      this.loadingInitial = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };

  registerSubAdmin = async (creds: IUserRoleForm) => {
    this.rolesLoading = "loading";
    try {
      const user = await agent.Profiles.createVendorSubAdmin(creds);
      if (user.isSuccessful) {
        runInAction(() => (this.rolesLoading = "success"));
        return user;
      } else
        runInAction(() => {
          this.rolesLoading = "";
          toast.info(user.responseMessage);
        });

      //   router.navigate("/activities");
      //   store.modalStore.closeModal();
    } catch (error) {
      this.rolesLoading = "";
      throw error;
    }
  };

  downloadFile = async (creds: TermsForm) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Terms.downloadfile(creds);
      // console.log(response);
      if (response.isSuccessful) {
        runInAction(() => (this.loadingInitial = ""));
        return response;
      } else
        runInAction(() => {
          this.loadingInitial = "";
          toast.info(response.responseMessage);
        });
    } catch (error) {
      this.loadingInitial = "";
      throw error;
    }
  };

  uploadFile = async (creds: string) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Terms.createUrl(creds);
      // console.log(response);
      if (response.isSuccessful) {
        runInAction(() => (this.loadingInitial = ""));
        return response;
      } else
        runInAction(() => {
          this.loadingInitial = "";
          toast.info(response.responseMessage);
        });
    } catch (error) {
      this.loadingInitial = "";
      throw error;
    }
  };
  accountVerification = async (id: string) => {
    this.status = "loading";
    try {
      const response = await agent.Account.verifyAccountNumber(id);
      if (response.isSuccessful)
        runInAction(() => {
          this.currentUserRole = response.data;
        });
      else {
        toast.info(response.responseMessage);
      }
      this.status = "";
      return response;
    } catch (error) {
      this.status = "";
      var error1 = "Error validating data";
      throw error1;
    }
  };

  fetchCac = async () => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Terms.getCAC();
      // console.log(response)
      if (response.isSuccessful)
        runInAction(() => {
          this.vendorCac = response.data;
        });
      else {
        toast.info(response.responseMessage);
        router.navigate("/vendor/shipping/returnlocationlist");
      }
      this.loadingInitial = "";
      return response;
    } catch (error) {
      this.guidStatus = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };

  uploadCac = async (creds: string) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Terms.updateCac(creds);
      // console.log(response);
      if (response.isSuccessful) {
        runInAction(() => (this.loadingInitial = ""));
        return response;
      } else
        runInAction(() => {
          this.loadingInitial = "";
          toast.info(response.responseMessage);
        });
    } catch (error) {
      this.loadingInitial = "";
      throw error;
    }
  };
}
